export default __webpack_public_path__ + "static/media/bg-title-01.015731ab.jpg";